module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_50_Slowniczek_Unit_10.mp3";